import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
import { AssignSenderLevel } from "../../DAL/create";
import { UpdateAssignLevelData } from "../../DAL/update";
import { enqueueSnackbar } from "notistack";

export default function UpdateAssignLevel() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({
    userCode: "",
    senderLevelId: "",
  });

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = {
      userCode: inputs?.userCode,
      senderLevelId: inputs?.senderLevelId,
    };

    const resp = await UpdateAssignLevelData(state?.id, data);

    if (resp?.data?.statusCode == 200) {
      enqueueSnackbar(resp?.data?.message, { variant: "success" });
      navigate(-1);
    } else {
      enqueueSnackbar(resp?.message, { variant: "error" });
    }
  };

  useEffect(() => {
    setInputs({
      senderLevelId: state?.senderLevel?.id,
      userCode: state?.userData?.code,
    });
  }, []);
  return (
    <>
      <div className="mainDiv">
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            marginBottom: "10px",
          }}
        >
          <ArrowBackIcon
            sx={{ cursor: "pointer" }}
            onClick={() => navigate(-1)}
          />
          <Typography variant="h5">Update Assign Level</Typography>
        </Box>
        <Grid container spacing={2} sx={{ marginTop: "10px" }}>
          <Grid item lg={6} md={12} sm={12} xs={12}>
            <TextField
              label="User RID"
              fullWidth
              name="userCode"
              value={inputs?.userCode}
              onChange={handleChange}
              size="small"
            />
          </Grid>
          <Grid item lg={6} md={12} sm={12} xs={12}>
            <TextField
              label="Sender Level ID"
              name="senderLevelId"
              value={inputs?.senderLevelId}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item lg={12} md={12} sm={12} xs={12} sx={{ textAlign: "end" }}>
            <Button
              sx={{
                background: "linear-gradient(to right, #5301d7, #008eca)",
                color: "white",
                borderRadius: "6px",
                textTransform: "none",
              }}
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </div>
    </>
  );
}
